import type { ReactNode } from 'react';
import styles from './FilterChip.module.scss';

export interface FilterChipGroupProps {
  children: ReactNode;
  'aria-label'?: string;
  className?: string;
}

export function FilterChipGroup({
  children,
  'aria-label': ariaLabel,
  className = '',
}: FilterChipGroupProps): JSX.Element {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className={`${styles.chipGroup} ${className}`.trim()}
    >
      {children}
    </div>
  );
}
